import Signal from "badmfck-signal";
import { AuthLogin } from "./AuthLogin";
import { AuthSignup } from "./AuthSignup";
import { ForgotPassword } from "./ForgotPassword";

import { RestorePassword } from "./RestorePassword";
import { InvitePage } from "./InvitePage";
import { InviteSignupPage } from "./InviteSignupPage";
import { ConfirmEmailPage } from "./ConfirmEmailPage";
import { KycReturnPage } from "./KycReturnPage";

const _TAuthSteps = ["login", "signup", "forgot"] as const;
export type TAuthSteps = (typeof _TAuthSteps)[number];
export const S_AUTH_CHANGE_VIEW = new Signal<TAuthSteps>("", cb => {
	// Landing links to /signup; start there but let S_AUTH_CHANGE_VIEW switch views afterwards.
	const signupPath = window.location.pathname === "/signup" && !new URLSearchParams(window.location.search).get("token");
	cb!(signupPath ? "signup" : _TAuthSteps[0]);
});
export const S_REGISTRATION_COMPLETE = new Signal<{
	login: string;
	pass: string;
}>("S_REGISTRATION_COMPLETE");

export const AuthView = () => {
	const state = S_AUTH_CHANGE_VIEW.use([]);
	const onRegistrationSuccess = S_REGISTRATION_COMPLETE.use([]);
	let content = null;

	if (onRegistrationSuccess) {
		return <AuthLogin login={onRegistrationSuccess.login} pass={onRegistrationSuccess.pass} />;
	}

	switch (state) {
		case "login":
			content = <AuthLogin />;
			break;
		case "signup":
			content = <AuthSignup />;
			break;
		case "forgot":
			content = <ForgotPassword />;
			break;
		default:
			content = <AuthLogin />;
	}

	if (window.location.pathname.indexOf("restore/") !== -1) {
		const position = window.location.pathname.indexOf("restore/") + 8;
		content = <RestorePassword code={window.location.pathname.slice(position)} />;
	}

	if (window.location.pathname === "/reset-password") {
		const query = new URLSearchParams(window.location.search);
		content = <RestorePassword code={query.get("token") || ""} />;
	}

	if (window.location.pathname.indexOf("invite/") !== -1) {
		const position = window.location.pathname.indexOf("invite/") + 7;
		content = <InvitePage code={window.location.pathname.slice(position)} />;
	}

	if (window.location.pathname === "/signup") {
		const token = new URLSearchParams(window.location.search).get("token");
		if (token) content = <InviteSignupPage token={token} />;
	}

	if (window.location.pathname === "/confirm-email") {
		const query = new URLSearchParams(window.location.search);
		content = <ConfirmEmailPage token={query.get("token") || ""} />;
	}

	if (window.location.pathname.startsWith("/kyc/")) {
		content = <KycReturnPage />;
	}

	return content;
};
